import React from "react";
import { Checkbox, FormControlLabel, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const IsDriverSetCheckbox = ({
    helperText,
    error,
    setFormValues,
    isFilter,
    selectedIsDriverSet,
    setSelectedIsDriverSet,
}) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [rtlPlugin],
    });

    const cacheLtr = createCache({
        key: 'ltr',
    });

    const handleChange = (event) => {
        const isChecked = event.target.checked;
        const value = isChecked ? "true" : "false";
        setSelectedIsDriverSet(value);
        if (setFormValues) {
            setFormValues((prevValues) => ({
                ...prevValues,
                isPagePaid: value,
            }));
        }
    };

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Box sx={{ display: 'flex' }}>
                <p
                    style={{
                        color: theme.palette.text.secondary,
                        fontSize: isTablet ? 12 : 14,
                        marginRight: 4,
                        marginLeft: 4
                    }}
                >
                    {t("setDriver")}
                </p>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={selectedIsDriverSet === "true"}
                            onChange={handleChange}
                            sx={{
                                color: theme.palette.primary.main,
                                '&.Mui-checked': {
                                    color: theme.palette.primary.main,
                                },
                            }}
                        />
                    }
                />
            </Box>
        </CacheProvider>
    );
};

export default IsDriverSetCheckbox;
